import React from "react";
import "./Invite_Wheel.css";
import Spin_Wheel_holder from "./Spin_Wheel_holder/Spin_Wheel_holder";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion, faClipboardList } from "@fortawesome/free-solid-svg-icons";
import Rules_Modal from "../Common/Common_Component/Common_Modal/Rules_Modal/Rules_Modal";

function Invite_Wheel() {
    const [modalShow, setModalShow] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const recordData = [
    {
      id: 1,
      name: "MEMBER679GT",
      image: "https://i.pravatar.cc/100",
      amount: "₹0.01",
      time: "2026-02-16 10:29:07",
    },
    {
      id: 2,
      name: "MEMBER245KD",
      image: "https://i.pravatar.cc/100",
      amount: "₹10.00",
      time: "2026-02-16 09:10:12",
    },
  ];

  return (
    <>
      <section className="Invite_Wheel">
        <div className="Common_white_header">
          <span className="back_btn" onClick={() => navigate(-1)}>
            ←
          </span>

          <h3>Invite Wheel</h3>


          <div className="icons_holder">
            <FontAwesomeIcon icon={faCircleQuestion}  onClick={() => setModalShow(true)}/>
           <FontAwesomeIcon icon={faClipboardList}  onClick={() => navigate("/wheel-cash-out-history")}/>
          </div>

            
        </div>

        <div className="container">
          {/* Amount Section */}
          <div className="amount_section">
            <p className="amount_timer">My Amount (67:36:16)</p>
            <h2 className="amount_value">₹ 476.01</h2>

            <button
              className="invite_btn"
              onClick={() => navigate("/wheel-cash-out-history")}
            >
              CASH OUT
            </button>
          </div>

          {/* Wheel */}
          <Spin_Wheel_holder />

          {/* Invite Button */}
          <div className="invite_btn_holder">
            <button className="invite_btn">INVITE FRIENDS TO GET SPIN</button>

            <p className="prize_text">ONLY ₹34.88 LEFT TO GET PRIZE ₹500.00</p>
          </div>

          {/* Record Section */}
          <div className="record_section">
            <h4 className="record_title">Record</h4>

            {recordData.map((item) => (
              <div className="record_item" key={item.id}>
                <div className="record_left">
                  <img src={item.image} alt="user" className="user_img" />

                  <span className="user_name">{item.name}</span>
                </div>

                <div className="record_right">
                  <div className="record_amount">{item.amount}</div>

                  <div className="record_time">{item.time}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Rules_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default Invite_Wheel;
